import { Invite } from '../models/commonModels';
import { CommonActionRequestType, RequestType } from '../reducers/requestReducer';
import { RequestActionType } from './requestActions';

export enum InviteActionType {
    GetInviteInfoInit = 'GET_INVITE_INFO/INIT',
    GetInviteInfoSuccess = 'GET_INVITE_INFO_SUCCESS',
}
export interface GetInviteInfo extends CommonActionRequestType {
    type: InviteActionType.GetInviteInfoInit;
    inviteId: string;
}
export const getInviteInfo = (inviteId: string): GetInviteInfo => ({
    requestActionType: RequestActionType.Init,
    requestType: RequestType.GetInviteInfo,
    type: InviteActionType.GetInviteInfoInit,
    inviteId,
});

export interface GetInviteInfoSuccess {
    type: InviteActionType.GetInviteInfoSuccess;
    payload: Invite;
}

export const getInviteInfoSuccess = (payload: Invite): GetInviteInfoSuccess => ({
    type: InviteActionType.GetInviteInfoSuccess,
    payload,
});

export type InviteActions = GetInviteInfoSuccess;
